import React, { useCallback, useMemo, useState } from 'react'
import { orionSystem } from '../../../../api/integrations'
import Loading from '../../../molecules/Loading'
import FieldDisplay from '../../../molecules/FieldDisplay'
import SydButton from '../../../commonDesign/Button'
import FlexRow from '../../../molecules/FlexRow'
import OpalCard from '../../../opal/OpalCard'

function OrionSystemConnectionInfo () {
  const { data, isLoading } = orionSystem.useConnectionInfo()
  const { mutateAsync: autoConfigure } = orionSystem.useOrionSystemAutoConfigure()
  const [processing, setProcessing] = useState(false)
  const handleAutoConfigure = useCallback(async () => {
    try {
      setProcessing(true)
      await autoConfigure()
    } finally {
      setProcessing(false)
    }
  }, [autoConfigure, setProcessing])

  const fields = useMemo(() => {
    if (!data) return []
    return [
      { label: 'Summit Firm ID', value: data.summitFirmId },
      { label: 'Orion Firm ID', value: data.orionFirmId || '--' },
      { label: 'Connection', value: data.connectionName },
      { label: 'Valid', value: data.isValid ? 'Yes' : 'No' },
      {
        label: 'System Configuration',
        value: data.systemConfiguration?.isConfigurationCurrent === true
          ? (<span className='bg-success-500 p-2'>Current</span>)
          : (
            <FlexRow>
              <span className='bg-danger-500 p-2'>Out of Sync</span>
              <SydButton processing={processing} icon='warning' variant='primary' onClick={handleAutoConfigure}>Auto-Configure</SydButton>
            </FlexRow>)
      }
    ]
  }, [data, handleAutoConfigure, processing])

  if (isLoading) {
    return (
      <OpalCard size='md'>
        <Loading />
      </OpalCard>
    )
  }

  return (
    <OpalCard size='md'>
      <header className='font-size-sm font-sans'>
        <FieldDisplay fields={fields} />
      </header>
    </OpalCard>
  )
}

export default OrionSystemConnectionInfo
